import React, { useEffect, useRef } from 'react';
import { useHandleClickLoading } from '../../components/Common/utils';
import { isIdTarget } from '../../store/actions/todoActions';
import { useDispatch } from 'react-redux';

const ListBlog = ({ data }) => {
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const handleClickLoading = useHandleClickLoading();

  useEffect(() => {
    const ele = containerRef.current;
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
      ele.style.cursor = "grabbing";

      pos = {
        left: ele.scrollLeft,
        top: ele.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      ele.scrollTop = pos.top - dy;
      ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
      ele.style.cursor = "grab";
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
    };

    ele.addEventListener("mousedown", mouseDownHandler);

    return () => {
      // Cleanup event listeners
      ele.removeEventListener("mousedown", mouseDownHandler);
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
    };
  }, []);
  return (
    <div className="flex flex-col  min-h-full ">
      <div className="relative w-full h-12 ">
        <div
          className="flex p-3 flex-row gap-2 overflow-x-auto overflow-hidden no-scrollbar absolute w-full h-full bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]"
          ref={containerRef}
        >
          {data.map((game,index) => (
            <button
              key={index}
              onClick={() => {
                handleClickLoading("/search-blog/" + game.nama);
                dispatch(isIdTarget(game.id));
              }}
              className={` px-1 rounded flex items-center `}
            >
              <span className="text-sm text-white whitespace-nowrap">
                {game.nama}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ListBlog;
